import { createContext } from "react";

import type { ApiCallers } from "@core/ports/http";

import type { accountAdminApi, oauthApi } from "@apis/account/api";
import type { adminApi, maintenanceApi, playgroundApi } from "@apis/admin/api";
import type { billingAdminApi } from "@apis/billing/api";
import type { busAdminApi } from "@apis/bus/api";

export interface AuthContextValue {
  readonly api: {
    readonly accountAdmin: ApiCallers<typeof accountAdminApi>;
    readonly admin: ApiCallers<typeof adminApi>;
    readonly billingAdmin: ApiCallers<typeof billingAdminApi>;
    readonly busAdmin: ApiCallers<typeof busAdminApi>;
    readonly maintenance: ApiCallers<typeof maintenanceApi>;
    readonly oauth: ApiCallers<typeof oauthApi>;
    readonly playground: ApiCallers<typeof playgroundApi>;
  };
}

export const AuthContext = createContext<AuthContextValue | null>(null);
